import { makeStyles, Theme } from "@material-ui/core";

export const useStylesInput = makeStyles((theme: Theme) => ({
    input: {
        "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px white inset"
        },
        fontFamily: "Helvetica"
    },
    formControl: {
        margin: theme.spacing(1),
        width: "100%"
    },
    switch: {
        marginTop: 20
    },
    switchLabel:{
        fontFamily:"Helvetica",
        fontSize:"13px",
        fontWeight:400,
        lineHeight:"15px"
    }
}));